import type { Style, CssObject, Component } from '@wix/thunderbolt-becky-types'
import { VISIBILITY_HIDDEN, VISIBILITY_VISIBLE } from './constants'
import { getPresetsInstanceWrapperSelector } from '@wix/thunderbolt-commons'

// @ts-ignore
export const shouldUseClassSelectors = () => globalThis.shouldUseClassSelectors

// lets keep the original signature for backward compatibility and rename when its ready
export const getRegularIdSelector = (compId: string, shouldTargetBuilderWrapper: boolean = false, supportExternalDependenciesCss: boolean = false, shouldForceIdSelector: boolean = false) => {
	if (shouldTargetBuilderWrapper) {
		return getPresetsInstanceWrapperSelector(compId, supportExternalDependenciesCss)
	}
	return shouldUseClassSelectors() && !shouldForceIdSelector ? `#main_MF :where(.${compId})` : `#${compId}`
}
export const getTemplateRepeaterIdSelector = (compId: string) =>
	shouldUseClassSelectors() ? `.${compId}` : `[id^="${compId}__"]`
export const getInflatedRepeaterIdSelector = (compId: string) => `[id="${compId}"]`
export const getInflatedDynamicSlotIdSelector = (compId: string, shouldTargetBuilderWrapper: boolean = false, supportExternalDependenciesCss: boolean = false) =>
	`:is(${getRegularIdSelector(compId, shouldTargetBuilderWrapper, supportExternalDependenciesCss)}, ${getTemplateRepeaterIdSelector(compId)})`

export const px = (value: number | undefined): string => (value ? `${value}px` : '0')

export const getVisibility = (component: Component) => {
	// @ts-expect-error - isHiddenByModes is only checked here so we are not adding it to Component type
	return component.isHiddenByModes ? VISIBILITY_HIDDEN : VISIBILITY_VISIBLE
}

export const mergeSelectors = (base: CssObject, ...overrides: Array<CssObject>): CssObject => {
	return Object.assign({}, base, ...overrides)
}

export const getDifferingAttributes = (outer: CssObject, inner: CssObject): CssObject => {
	const differingAttributes: CssObject = {}
	for (const key in inner) {
		if (!outer.hasOwnProperty(key) || outer[key] !== inner[key]) {
			differingAttributes[key] = outer[key]
		}
	}
	return differingAttributes
}

export const areCssAttributesEqual = (outer: CssObject, inner: CssObject): boolean => {
	for (const key in inner) {
		if (!outer.hasOwnProperty(key) || outer[key] !== inner[key]) {
			return false
		}
	}
	return true
}

export const getSTCSS = (styleItem: Style): string =>
	styleItem.style?.properties?.['$st-css'] || styleItem.style?.properties?.['st-css'] || ''
